import type { Context } from '../../../overmind';
import { routes } from '../../../overmind/machines/router';

export const handleConfigurationV2Route = (context: Context) => ({
  [routes.configurationV2]: () => {
    context.actions.internal.setRoute({ route: 'configurationV2' });
  }
});
